import React from 'react';
import { AppBar, Toolbar, Typography, Box, Slide } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import useScrollTrigger from '@mui/material/useScrollTrigger';

const useStyles = makeStyles({
  root: {
    boxShadow: 'none',
    backgroundColor: 'rgba(229, 229, 229, 0.73)',
    '& .MuiToolbar-root': {
      flexDirection: 'row-reverse',
    },
  },
  logo: {
    borderRadius: 10,
    width: 82,
  },
});

const TopBar = () => {
  const classes = useStyles();
  const trigger = useScrollTrigger();

  return (
    <Slide in={!trigger}>
      <AppBar position="sticky" color="transparent" className={classes.root}>
        <Toolbar>
          <Box display="flex" m={2}>
            <img
              src="/images/logo.png"
              alt="SAY-logo"
              className={classes.logo}
            />
          </Box>
          <Typography variant="h1">SAY PANEL</Typography>
        </Toolbar>
      </AppBar>
    </Slide>
  );
};

export default TopBar;
